import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/denim-glasses/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
